export default {
  links: [
    { rel:'apple-touch-icon', sizes:'180x180', href:'/favicon/apple-touch-icon.png' },
    { rel:'icon', type:'image/png', sizes:'32x32', href:'/favicon/favicon-32x32.png' },
    { rel:'icon', type:'image/png', sizes:'16x16', href:'/favicon/favicon-16x16.png' },
    { rel:'manifest', href:'/favicon/site.webmanifest' },
    { rel:'mask-icon', href:'/favicon/safari-pinned-tab.svg', color:'#890024' },
    { rel:'shortcut icon', href:'/favicon/favicon.ico' }
  ],
  metas: [
    { name:'apple-mobile-web-app-title', content:'Faramet' },
    { name:'application-name', content:'Faramet' },
    { name:'msapplication-TileColor', content:'#890024' },
    { name:'msapplication-config', content:'/favicon/browserconfig.xml' },
    { name:'theme-color', content:'#890024' }
  ]
}
